import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Bubble } from '../BubbleElement/BubbleElement';
import { useTranslation } from 'react-i18next';
import { setFilter } from '../../../redux/actions/filter';
import { capitalizeFirstLetter } from '../../../services/stringUtil';

export const DisbursementDataFilterBubble = () => {
  const filter = useSelector<any, any>(state => state.filter);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const closeBubble = () => {
    dispatch(
      setFilter({
        ...filter,
        common: {
          ...filter.common,
          isAnnual: 'accumulated',
        },
      }),
    );
  };

  return (
    <>
      {filter.common.isAnnual && (
        <Bubble
          key={'disbursement_data'}
          itsHidden={false}
          label={capitalizeFirstLetter(t('disbursement_data_' + filter.common.isAnnual))}
          closeBubble={closeBubble}
        />
      )}
    </>
  );
};
